import { axios } from "./AxiosInstance";

interface IFilterQuestion {
  page?: number;
  size?: number;
  questionType?: string;
  level?: string;
  subject?: string;
  searchText?: string;
}
interface IAdderQuestion {
  page?: number;
  size?: number;
  questionType?: string;
  level?: string;
  subjectId: string;
  searchText?: string;
  programId: string;
}
interface IAddQuestion {
  file: any;
  questionType: string;
  subject: string;
}



interface IUpdateLAQuestion {
  _id: string | undefined;
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  type: string;
}
interface IUpdateTFQuestion {
  _id: string | undefined;
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  type: string;
  tFAnswer: string;
}

interface IUpdateMCQSQuestion {
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  mcqSOptions: string[];
  mcqSAnswer: number;
  questionMarks: number;
}



interface IUpdateLongQuestion {
  _id: string | undefined;
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  type: string;
  questionlong: string[];
  //questionlongAnswer: string[];
}

interface IUpdateDiagramQuestion {
  _id: string;
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  type: "diagram";
  questionDiagram?: string | Record<string, any>; 
  diagramAnswerKey?: string;                    
  diagramInstructions?: string;                
  questionImg?: string;                          
  justificationImg?: string;  
  questionMarks: number;                  
}

interface IUpdateShortQuestion {
  _id: string | undefined;
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  type: string;
  questionShort: string[];
  /*questionShortAnswer: string[];*/
}



interface IUpdateMCQMQuestion {
  question: string;
  positiveMarks: number;
  negativeMarks: number;
  answerJustification: string;
  tags: string[];
  level: QuestionLevel;
  mcqMAnswer: number[];
  mcqMOptions: string[];
}

// export const filterQuestion = async ({
//   page,
//   size,
//   questionType,
//   level,
//   subject,
//   searchText,
// }: IFilterQuestion) => {
//   try {
//     const { data } = await axios.post(`/question/filter`, {
//       page,
//       size,
//       questionType,
//       level,
//       subject,
//       searchText,
//     });
//     return data;
//   } catch (error: any) {
//     throw Error(error.response.data.message);
//   }
// };

export const filterQuestion = async ({
  page,
  size,
  questionType,
  level,
  subject,
  searchText,
}: IFilterQuestion) => {
  try {
    const { data } = await axios.post(`/question/filter`, {
      page,
      size,
      questionType,
      level,
      subject,
      searchText,
    });
    
    return data;
  } catch (error: any) {
    throw Error(error?.response?.data?.message || "Server error");
  }
};


export const questionAdderFilter = async ({
  page,
  size,
  level,
  questionType,
  subjectId,
  searchText,
  programId,
}: IAdderQuestion) => {
  try {
    const { data } = await axios.post(`/question/adder-filter`, {
      questionType,
      level,
      subjectId,
      programId,
      searchText,
      page,
      size,
    });
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const addQuestions = async ({

  file,
  questionType,
  subject,
}: IAddQuestion) => {
  
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("questionType", questionType);
    formData.append("subjectName", subject);
    const { data } = await axios.post(`/question/add`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};
//Manual Insert Questions

export const addManualQuestion = async (payload: any) => {
  try {
    const { data } = await axios.post("/question/manual-insert", payload);
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Server error");
  }
};


// export const addManualQuestion = async (payload: Record<string, any>) => {
//   debugger;
//   const formData = new FormData();

//   // Add basic fields
//   formData.append("type", payload.type);
//   formData.append("question", payload.question);
//   formData.append("subject", payload.subject);
//   formData.append("explanation", payload.explanation || "");

//   // Type-specific fields
//   switch (payload.type) {
//     case "MCQS":
//       payload.mcqOptions.forEach((opt: string) => formData.append("mcqOptions[]", opt));
//       formData.append("mcqAnswer", payload.mcqAnswer.toString()); // index
//       break;

//     case "MCQM":
//       payload.mcqMOptions.forEach((opt: string) => formData.append("mcqMOptions[]", opt));
//       payload.mcqMAnswer.forEach((i: number) => formData.append("mcqMAnswer[]", i.toString()));
//       break;

//     case "TF":
//       formData.append("tfAnswer", payload.tfAnswer ? "true" : "false");
//       break;

//     case "Short":
//       formData.append("shortAnswer", payload.shortAnswer);
//       break;

//     case "Long":
//       formData.append("longAnswer", payload.longAnswer);
//       break;

//     case "diagram":
//       if (payload.image instanceof File) {
//         formData.append("image", payload.image);
//       }
//       formData.append("diagramAnswer", payload.diagramAnswer);
//       break;

//     default:
//       throw new Error("Unsupported question type");
//   }

//   const response = await fetch("/api/questions/manual-insert-question", {
//     method: "POST",
//     body: formData,
//   });

//   if (!response.ok) throw new Error("Failed to insert question");

//   return response.json();
// };


export const fetchQuestionById = async (id: string, type: string) => {
  try {
    const { data } = await axios.get(`/question/${type}/${id}`);
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const updateLAQuestion = async (values: IUpdateLAQuestion) => {
  try {
    const { data } = await axios.patch(`/question`, values);
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const updateMCQSQuestion = async (values: FormData) => {
  try {
    // Corrected to use FormData and the new endpoint
    const { data } = await axios.patch(`/question`, values, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};


export const updateMCQMQuestion = async (values: FormData) => {
  try {
    // Corrected to use FormData and the new endpoint
    const { data } = await axios.patch(`/question`, values, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const updateTFQuestion = async (values: IUpdateTFQuestion) => {
  try {
    const { data } = await axios.patch(`/question`, values);
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

//AIEdge
export const UpdateLongQuestion = async (values: IUpdateLongQuestion) => {
  try {
    const { data } = await axios.patch(`/question`, values);
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const UpdateShortQuestion = async (values: IUpdateShortQuestion) => {
  try {
    const { data } = await axios.patch(`/question`, values);
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};




export const uploadDiagramImage = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axios.post(`/question/diagram/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error: any) {
    throw Error(error?.response?.data?.message || "Failed to upload diagram image");
  }
};

// export const UpdateDiagramQuestion = async (values: Partial<IUpdateDiagramQuestion>) => {
//   try {
//     if (!values._id) throw new Error("Question _id is required");
    

//     const { data } = await axios.put(`/question/diagram`, values);
//     return data;
//   } catch (error: any) {
//     throw Error(error?.response?.data?.message || "Failed to update diagram question");
//   }
// };


export const UpdateDiagramQuestion = async (values: FormData | Partial<IUpdateDiagramQuestion>) => {
try {
const config = { transformRequest: [(data: any) => data] }; // keep FormData intact
if (!(values instanceof FormData) && !(values as any)?._id) {
throw new Error("Question _id is required");
}
const { data } = await axios.put(`/question/diagram`, values, config);
return data;
} catch (error: any) {
throw Error(error?.response?.data?.message || "Failed to update diagram question");
}
};


export const getQuestionByTypeAndId = async (type: string, id: string) => {
  const url = `/api/question/${type.toLowerCase()}/${id}`;
  const { data } = await axios.get(url);
  return data;
};

// export const deleteQuestionById = async (id: string) => {
//   try {
//     const { data } = await axios.delete(`/question/${id}`);
//     return data;
//   } catch (error: any) {
//     throw Error(error.response.data.message);
//   }
// };

export const deleteQuestionsById = async (ids: string[]) => {
  try {
    const { data } = await axios.post(`/question/deleteMany`, { ids });
    return data;
  } catch (error: any) {
    throw Error(error.response.data.message);
  }
};

export const fetchDiagramQuestionById = async (id: string) => {
  try {
    const { data } = await axios.get(`/question/diagram/${id}`);
    return data;
  } catch (error: any) {
    throw Error(error?.response?.data?.message || "Failed to fetch diagram question");
  }
};